import React from "react";
import {
    Paper, Box, Typography, useTheme,
} from "@mui/material";
import CasablancaSpinner from "./CasablancaSpinner";
import { LoadingSpinnerType, useConfigurationStore } from "../../stores/ConfigStore";
import { Grid, Rings, Watch } from "react-loader-spinner";
import ConnectionSpinner from "./ConnectionSpinner";
import { useTenantStore } from "../../stores/TenantStore";
import AppContainer from "../layout/AppContainer";
import IFrame from "../shared/IFrame";

const LoadingSpinner = ({ type }: { type: LoadingSpinnerType }) => {
    const theme = useTheme()
    switch (type) {
        case LoadingSpinnerType.Casablanca:
            return <CasablancaSpinner />;
        case LoadingSpinnerType.Grid:
            return <Grid color={theme.palette.primary.main} height={150} radius={"12px"} />;
        case LoadingSpinnerType.Watch:
            return <Watch color={theme.palette.primary.main} height={100} radius={"45px"} wrapperClass="custom-watch-spinner" />;
        case LoadingSpinnerType.Rings:
            return <Rings
                height="160"
                width="160"
                radius={6}
                color={theme.palette.primary.main}
            />
        default:
            return null;
    }
};

interface IProps {
    isVisible: boolean;
}

const LoadingScreen: React.FC<IProps> = ({ isVisible }) => {
    const { configuration } = useConfigurationStore()
    const { isRequestPending, isConnectionError, connectionErrorMessage, activeState } = useTenantStore();
    return (
        <div style={{
            width: "100%",
            height: "100vh",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: -1,
            transition: 'opacity 1s ease-in-out',
            opacity: isVisible ? 1 : 1,
            transitionDelay: activeState.emptyResponse ? '0ms' : '500ms',
        }}>

            {configuration.setup.placeholderUrl ? (
                <>
                    <ConnectionSpinner deviceName={configuration.setup.deviceName || ''} isConnectionError={isConnectionError} connectionErrorMessage={connectionErrorMessage} />
                    <IFrame
                        src={configuration.setup.placeholderUrl}
                        style={{ position: "absolute", top: 0, left: 0 }}
                    /></>
            ) :
                <AppContainer>
                    <Paper elevation={0}>
                        <ConnectionSpinner deviceName={configuration.setup.deviceName || ''} isConnectionError={isConnectionError} connectionErrorMessage={connectionErrorMessage} />
                        <Box display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            height="100%"
                            px={{ xs: 2, sm: 4 }}
                            mt={{ sm: -20 }}
                            gap={2}>
                            <LoadingSpinner type={configuration.design.loadingSpinnerType} />
                            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                                <Box display="flex" alignItems="center" mb={2}>
                                    <Typography variant="h3" textAlign="center">
                                        Bitte warten...
                                    </Typography>
                                </Box>
                                <Box display="flex">
                                    <Typography variant="h5" fontWeight={200} textAlign="center">
                                        Ihr Formular wird in Kürze angezeigt
                                    </Typography>
                                </Box>
                            </Box>

                        </Box>
                    </Paper>
                </AppContainer>
            }
        </div>
    );
};

export default LoadingScreen;
